import { useState } from "react";
import { useTranslations } from "next-intl";
import {
  useRemoveSelectedItemFromCloset,
  useReloadCustomizableCloset,
} from "@hooks/use-customizable-closet";
import { useSelectItems } from "@hooks/use-buy-closet-items";
import Link from "@components/core/Link";
import Button from "@components/core/Button";
import closetStates from "@utils/constants/closetStates";

function ClosetItemButtons({ closetState, closetItem, closetHasMailboxPickingRequested }) {
  const t = useTranslations("common");

  const removeSelectedItemFromCloset = useRemoveSelectedItemFromCloset();
  const reloadCustomizableCloset = useReloadCustomizableCloset();
  const selectItems = useSelectItems();

  const [deletingSelectedItem, setDeletingSelectedItem] = useState(false);

  const product = closetItem?.product || {};

  async function deleteClosetItem() {
    setDeletingSelectedItem(true);

    try {
      await removeSelectedItemFromCloset(closetItem.id);
    } catch (error) {
      setDeletingSelectedItem(false);
      reloadCustomizableCloset();
    }
  }

  function changeButtons() {
    return (
      <div className="closet-items-list-card-buttons-container">
        <div className="closet-items-list-card-button">
          <Link
            href={`/products/${product.slug}`}
            className="w-100"
          >
            <Button
              variant="ghost-primary"
              fullWidth
            >
              {t("drawer.card.modify")}
            </Button>
          </Link>
        </div>
        <div className="closet-items-list-card-button btn-right">
          <Button
            variant="ghost-primary"
            fullWidth
            onClick={deleteClosetItem}
            loading={deletingSelectedItem}
          >
            {t("drawer.card.remove")}
          </Button>
        </div>
      </div>
    );
  }

  function rateAndBuyButtons() {
    return (
      <div className="closet-items-list-card-buttons-container">
        <div className="closet-items-list-card-button">
          {closetItem.review?.long_review_done ? (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ padding: "12px 32px" }}
            >
              <span
                className="text-primary font-weight-medium"
                style={{ lineHeight: "16px" }}
              >
                {t("drawer.card.rating", { rating: closetItem.review.rating })}
              </span>
            </div>
          ) : (
            <Link
              href={`/closet_items/${closetItem.id}/review`}
              className="w-100"
            >
              <Button
                variant="ghost-primary"
                fullWidth
                trackingName={`closet_${closetState}_long_review`}
              >
                {t("drawer.card.rate")}
              </Button>
            </Link>
          )}
        </div>

        {closetState === closetStates.received &&
          !closetHasMailboxPickingRequested &&
          !closetItem.purchased &&
          !closetItem.purchasing && (
            <div className="closet-items-list-card-button btn-right">
              <Link
                href={`/closets/${closetItem.closet_id}/buy_items`}
                className="w-100"
              >
                <Button
                  variant="ghost-primary"
                  fullWidth
                  onClick={() => selectItems([closetItem.id])}
                >
                  {t("drawer.card.buy")}
                </Button>
              </Link>
            </div>
          )}
      </div>
    );
  }

  switch (closetState) {
    case closetStates.readyToChange:
      return changeButtons();
    case closetStates.received:
    case closetStates.postReturned:
    case closetStates.returned:
    case closetStates.purchased:
      return rateAndBuyButtons();
    default:
      return null;
  }
}

export default ClosetItemButtons;
